// extracted by mini-css-extract-plugin
module.exports = {"BLOCK":"Plate_BLOCK__3e2uM","BLOCK___clickable":"Plate_BLOCK___clickable__3evpE","inner":"Plate_inner__2Gntn"};